export default __webpack_public_path__ + "static/media/SWT1000.34I-29553_-17114_0.136bc464.jpg";